module.exports = __webpack_public_path__ + "static/img/page_06.fa70047b.png";